// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LC-U","col":"styles_col__34hvU"};